import { useEffect, useState } from "react";
import { Image, Skeleton, Stack } from "@chakra-ui/react"; // Assuming Chakra UI for Image component
import { getMediaURL } from "utils/misc";

const PhotosGalleryImageComponent = ({
  src,
  isMobileFilePhotoPage,
  type,
  ...props
}) => {
  const [srcURL, setSrcURL] = useState(null);
  const [imageLoading, setImageLoading] = useState(true);

  useEffect(() => {
    const fetchMediaURL = async () => {
      try {
        if (!src) {
          console.warn("No src provided to PhotosGalleryImageComponent");
          setImageLoading(false);
          return;
        }
        const res = await getMediaURL(src, props.imei, type);
        setSrcURL(res?.data?.data);
        setImageLoading(false);
      } catch (error) {
        console.error("Error fetching media URL:", error);
        setImageLoading(false);
        setSrcURL(undefined);
      }
    };

    fetchMediaURL();
  }, [src]);

  const isVideo = (src) => {
    return src?.indexOf(".mp4") > -1;
  };

  const isImage = (src) => {
    return (
      src?.indexOf(".png") > -1 ||
      src?.indexOf(".jpg") > -1 ||
      src?.indexOf(".gif") > -1
    );
  };

  if (imageLoading) {
    return (
      <Stack gap="6" maxW="lg">
        <Skeleton height="200px" />
      </Stack>
    );
  }
  if (isImage(src)) {
    return <Image src={srcURL} {...props} />;
  } else if (isVideo(src)) {
    return (
      <video
        src={srcURL}
        className="videoTag"
        controls={isMobileFilePhotoPage ? false : true}
        controlsList="nodownload"
        style={{
          width: "100%",
          height: "100%",
          objectFit: props.objectFit || "cover",
          // pointerEvents: isMobileFilePhotoPage ? "none" : "auto",
        }}
      />
    );
  } else {
    return <p>Unsupported media type</p>;
  }
};

export default PhotosGalleryImageComponent;
